"use strict";

import _ from "lodash";

import Page from "./AddProperty.jsx";

export const auth = true;
export const Component = Page;
